import setupStore from './redux';

const appStore = setupStore({
	apiService: BT.lib.apiCall
});

export default appStore;
